// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"styles_loaderWrapper__XyrqQ","ldsDefault":"styles_ldsDefault__1JWVq"};